import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { CasAddressesApi } from "../../../services/cas/CasAddressesApi";

export const useGetUserAddresses = (isFetchEnabled: boolean) => {
  const addressApiClient = CasAddressesApi.init();
  return useQuery([QUERY_KEYS.addresses, isFetchEnabled], () => addressApiClient.getAddresses(), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: isFetchEnabled,
  });
};
